import { useEffect, useState } from 'react';
import { GRAPH_STACKING_TYPES, GRAPH_VIEWS } from './Graph/graph.views';

const useGraphView = ({ isOverlapping = false } = {}) => {
  const [viewType, setViewType] = useState(GRAPH_VIEWS.PERCENT);
  const [stackingType, setStackingType] = useState(
    GRAPH_STACKING_TYPES.PERCENT
  );

  const onChangeViewType = () => {
    switch (viewType.key) {
      case GRAPH_VIEWS.PERCENT.key:
        return setStackingType(GRAPH_STACKING_TYPES.PERCENT);
      default:
        if (stackingType.key === GRAPH_STACKING_TYPES.PERCENT.key)
          return setStackingType(GRAPH_STACKING_TYPES.NORMAL);
    }
  };
  const getConfig = () => viewType.getConfig({ stackingType });

  const initViewAccordingIsOverlapping = () => {
    if (isOverlapping) {
      if (viewType.key === GRAPH_VIEWS.PERCENT.key)
        setViewType(GRAPH_VIEWS.FTE);
      if (stackingType.key !== GRAPH_STACKING_TYPES.SIDE_BY_SIDE.key)
        setStackingType(GRAPH_STACKING_TYPES.SIDE_BY_SIDE);
    }
  };

  useEffect(() => {
    onChangeViewType();
  }, [viewType.key]);

  useEffect(() => {
    initViewAccordingIsOverlapping();
  }, [isOverlapping]);

  return {
    viewType,
    setViewType,
    getConfig,
    stackingType,
    setStackingType,
    isOverlapping
  };
};

export default useGraphView;
